import {getRunningTimeDuration} from '@domain/running-times'
import {Iso8601} from '@hconnect/uikit'
import {Box, Stack, Typography} from '@mui/material'
import {useTranslation} from 'react-i18next'

import {COMMON_RUNNING_TIMES_WIDGET_NAMESPACE} from '../consts'

type StoppageSplitDurationDetailsProps = {
  stoppageTimeRangeUtc: [Iso8601, Iso8601 | undefined]
  splitDateUtc: Iso8601
  timezone: string
}

export const StoppageSplitDurationDetails = ({
  stoppageTimeRangeUtc,
  splitDateUtc,
  timezone
}: StoppageSplitDurationDetailsProps) => {
  const {
    t,
    i18n: {language}
  } = useTranslation(COMMON_RUNNING_TIMES_WIDGET_NAMESPACE)
  const [stoppageStart, stoppageEnd] = stoppageTimeRangeUtc

  return (
    <Box display="flex" gap={1}>
      <Stack textAlign="left" data-test-id="split-details-start">
        <Typography variant="caption">{t('splitStoppage.label.part1')}</Typography>
        <Typography variant="subtitle1">
          {getRunningTimeDuration({
            beginUtc: stoppageStart,
            endUtc: splitDateUtc,
            translationFn: t,
            timezone,
            language
          })}
        </Typography>
      </Stack>
      <Stack textAlign="end" data-test-id="split-details-end">
        <Typography variant="caption">{t('splitStoppage.label.part2')}</Typography>
        <Typography variant="subtitle1">
          {getRunningTimeDuration({
            beginUtc: splitDateUtc,
            endUtc: stoppageEnd,
            translationFn: t,
            timezone,
            language
          })}
        </Typography>
      </Stack>
    </Box>
  )
}
